/**
 * @author: varun
 * Anything related to Email templates.
 */

var AppCtrlTinymceModule = angular.module('AppCtrl.tinymce.directive', ['AppCtrl.campaign.constant', 'jv.Campaigns.jvTinymce']);
AppCtrlTinymceModule.factory('draggableTemplate', ['constantService', function (constantService) {
    return function (content) {
        return constantService.REGULAR_LINK_TEMPLATE.format(content);
    };
}]);
AppCtrlTinymceModule.factory('joinUsDraggableTemplate', ['constantService', function (constantService) {
    return function (content) {
        return constantService.JOIN_US_APP_TEMPLATE.format(content);
    };
}]);

AppCtrlTinymceModule.directive('jvTinymceDraggable', ['$compile', function ($compile) {
    return {
        link: function (scope, element, attr) {
            $(element).draggable({
                revert: true,
                addClasses: false,
                cursor: 'default',
                helper: 'clone',
                iframeFix: true,
                opacity: 0.90,
                refreshPositions: true
            });
            scope.$watch('content', function (val) {
                if (angular.isDefined(val)) {
                    $(element).data('content', val);
                }
            });
            if (angular.isDefined(attr.editLink)) {
                var editLink = angular.element('<a href="" class="jv-edits large" ng-click="editLink()"><i class="icon icon-edit dark-sec large"></i></a>');
                $(element).append($compile(editLink)(scope));
            }
        },
        scope: {
            content: '@',
            title: '@',
            editLink: '&'
        },
        template: '{{title}}'
    };
}]);

AppCtrlTinymceModule.factory('Draggable', function () {
    return function (textToShow, content, templateFunc, metaData) {
        var object = {};
        object.text = textToShow;
        object.content = templateFunc(content);
        object.metadata = angular.extend(metaData || {}, {
            templateVariable: content
        });
        return object;
    };
});
AppCtrlTinymceModule.factory('TinyMceMessageToContent', function () {
    return function (message, links, useMessage) {
        var i = 0,
            j = links.length,
            element;

        if (useMessage) {
            element = message;
            for (; i < j; i++) {
                var re = /\[(.*)\]/i;
                var linkVariable = links[i].metadata.templateVariable.match(re)[1];
                var escapedLinkVariable = linkVariable.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&');
                var regexString = new RegExp('<input [^>]*value\s*=\s*["\']' +  '\\[' + escapedLinkVariable +'\\]' + '["\']' + '\s*[^>]*>', "g");
                element = element.replace(regexString, links[i].metadata.templateVariable);
            }
        } else {
            element = document.createElement('html');
            // replace head/body tags with placeholder comments because they
            // get removed when setting as html
            message = message.replace(/<(\/?(body|head))>/g, '<!-- $1 -->');
            try {
                /* This was previously set as $(element).html(message);. It was causing an issue where a script tag alert
                 * added in head and body tag was getting executed.(https://jobvite.atlassian.net/browse/SEC-152)
                 * Changed it to use element.innerHTML and the script does not execute anymore.
                 * Also, on the back-end we are using AntiSamy to clean content as well.*/
                element.innerHTML = message;
            } catch (err) {
                // catch script errors so we can continue
            }
            for (; i < j; i++) {
                $(element).find("input[value='" + links[i].metadata.templateVariable + "']").replaceWith(links[i].metadata.templateVariable);
            }

            var content;
            // replace placeholders back with original tags
            content = $(element).html().replace(/<!-- (\/?(body|head)) -->/g, '<$1>');
            return content;
        }

        return element;
    };
});
AppCtrlTinymceModule.factory('ContentToTinyMceMessage', function () {
    return function (message, links) {
        var i = 0,
            j = links.length;
        for (; i < j; i++) {
            message = message.split(links[i].metadata.templateVariable).join(links[i].content);
        }
        return message;
    };
});
// Predefined Templates.
AppCtrlTinymceModule.factory('predefinedTemplates', ['Draggable', 'draggableTemplate', function (Draggable, draggableTemplate) {
    var predefinedTemplates = {
        User: [
            Draggable('[sender-first-name]', '[sender-first-name]', draggableTemplate, {
                name: ''
            }),
            Draggable('[sender-last-name]', '[sender-last-name]', draggableTemplate, {
                name: ''
            }),
            Draggable('[recipient-first-name]', '[recipient-first-name]', draggableTemplate, {
                name: ''
            }),
            Draggable('[recipient-last-name]', '[recipient-last-name]', draggableTemplate, {
                name: ''
            }),
            Draggable('[recipient-email]', '[recipient-email]', draggableTemplate, {
                name: ''
            })
        ],
        Company: [
            Draggable('[company-name]', '[company-name]', draggableTemplate, {
                name: ''
            }),
            Draggable('[company-logo]', '[company-logo]', draggableTemplate, {
                name: ''
            })
        ]
    };

    if (window.gdprEnabled === 'true' && window.consentFormEnabled === 'true') {
        var contactConsentLinkTokenTemplate = Draggable('[contact-consent-link]', '[contact-consent-link]', draggableTemplate, {
            name: ''
        });
        predefinedTemplates.User.push(contactConsentLinkTokenTemplate);
    }
    return predefinedTemplates;
}]);
AppCtrlTinymceModule.factory('selectLayoutService', [function () {
    var _width = 98;
    var clearfix = '<style>.group:before,.group:after{content: "";display: table;}.group:after {clear: both;}.group {zoom: 1;</style>';
    var companyLogo = '<input style="font-size: 12px; color: #ffffff; text-shadow: 0px -1px 1px rgba(0, 0, 0, 0.3); border: none; padding: 5px; text-align: center; background-color: #3d87cf; border-radius: 3px; display: inline-block; margin: 2px 5px;" type="button" value="[company-logo]" disabled="disabled" />'
    var layout = {
        1: '',
        2: clearfix + '<div style="padding: 10px; width: ' + _width + '%">' +
            '<div style="border-bottom: 1px solid #cccccc; padding-bottom: 15px;"><span>' + companyLogo + '</span></div>' +
            '<div style="padding-top: 15px;padding-bottom: 15px;border-bottom: 1px solid #cccccc">' + i18n['JV_EMAILTEMPLATE_YOUR_CONTENT_HERE'] + '</div>' +
            '</div>' +
            '<div style="padding: 10px; width: ' + _width + '%">' + i18n['JV_EMAILTEMPLATE_FOOTER'] + '</div>',
        3: clearfix + '<div style="padding: 10px; width: ' + _width + '%">' +
            '<div style="border-bottom: 1px solid #cccccc; padding-bottom: 15px;"><span>' + companyLogo + '</span></div>' +
            '<div class="clearfix" style="width: 100%; padding-top: 15px;padding-bottom: 15px;border-bottom: 1px solid #cccccc">' +
            '<table width="100%"><tbody><tr valign="top">' +
            '<td width="48%" style="padding: 10px;"> ' + i18n['JV_EMAILTEMPLATE_YOUR_CONTENT_HERE'] + '</td>' +
            '<td width="48%" style="padding: 10px;">' + i18n['JV_EMAILTEMPLATE_YOUR_CONTENT_HERE'] + '</td>' +
            '</tr></tbody></table>' +
            '</div>' +
            '</div>' +
            '<div style="padding: 10px; width: ' + _width + '%">' + i18n['JV_EMAILTEMPLATE_FOOTER'] + '</div>',
        4: clearfix + '<div style="padding: 10px; width: ' + _width + '%">' +
            '<div style="border-bottom: 1px solid #cccccc; padding-bottom: 15px;"><span>' + companyLogo + '</span></div>' +
            '<div style="padding-top: 15px;padding-bottom: 15px;border-bottom: 1px solid #cccccc">' + i18n['JV_EMAILTEMPLATE_YOUR_CONTENT_HERE'] + '</div>' +
            '<div style="padding-top: 15px;padding-bottom: 15px;border-bottom: 1px solid #cccccc">' + i18n['JV_EMAILTEMPLATE_JOB_LISTING'] + '</div>' +
            '</div>' +
            '<div style="padding: 10px; width: ' + _width + '%">' + i18n['JV_EMAILTEMPLATE_FOOTER'] + '</div>'
    };
    return function (layoutNumber) {
        return layout[layoutNumber];
    };
}]);

AppCtrlTinymceModule.controller('EmailsTemplateController', ['$scope', 'campaignService', '$location', '$rootScope', 'modalService', 'actionModalService',
    '$q', 'Draggable', '$routeParams', 'constantService', '$timeout', 'predefinedTemplates', 'selectLayoutService', 'draggableTemplate', 'TinyMceMessageToContent', 'ContentToTinyMceMessage',
    function ($scope, campaignService, $location, $rootScope, modalService, actionModalService, $q, Draggable, $routeParams, constantService, $timeout, predefinedTemplates, selectLayoutService, draggableTemplate, TinyMceMessageToContent, ContentToTinyMceMessage) {
        campaignService.getDetails();
        $scope.newEmailContents = {
            htmlMessage: ''
        };
        if (!angular.isDefined($routeParams.meid)) {
            $scope.newEmailContents.from = _jvselfUser.fullName;
        }
        $scope.templates = predefinedTemplates;
        $scope.customTemplates = [];
        // Hash used for editing the templates.
        var _customTemplatesHash = {};
        $scope.requisitionObject = [];

        $scope.reqIds = [];

        function reinitialize() {
            $scope.newEmailContents = {};
        }
        // Action for cancel
        $scope.cancelEmail = function () {
            $location.path('campaign/email/email/' + $routeParams.ceid);
        };

        // Preview email.
        $scope.previewEmail = function () {
            $scope.saveEmail(true);
        };


        $scope.buildAllLinks = function() {
          const allLinks = [].concat($scope.templates.User).concat($scope.templates.Company).concat($scope.customTemplates).concat($scope.requisitionObject);
          return {'allLinks': allLinks, 'type': 'EMAIL'};
        };

        //Action for save email.
        $scope.saveEmail = function (ifPreview) {

            $scope.$emit('syncEditorContent');

            // first remove all the error flags.
            var errorConstants = ['subject', 'htmlMessage', 'from'];
            var formInvalid = false;
            angular.forEach(errorConstants, function (value) {
                $scope.newEmailContents[value + 'Error'] = false;
                if ($scope.newEmailContents[value] === undefined || $scope.newEmailContents[value] === null || $scope.newEmailContents[value].trim() === '') {
                    $scope.newEmailContents[value + 'Error'] = true;
                    formInvalid = true;
                }
            });
            // Don't submit the form if there are errors on the page.
            if (formInvalid) {
                return;
            }

            var allLinks = $scope.buildAllLinks().allLinks;
            var _htmlMessage = TinyMceMessageToContent($scope.newEmailContents.htmlMessage, allLinks);
            var customActionTemplates = [];
            angular.forEach($scope.customTemplates, function (draggable) {
                customActionTemplates.push(draggable.metadata);
            });
            var metaDataObj = {
                actions: customActionTemplates
            };
            var _reqStructures = [];
            var requisitionObjectTemp = '';
            angular.forEach($scope.requisitionObject, function (reqObject) {
                requisitionObjectTemp = !!reqObject ? angular.copy(reqObject.metadata) : null;
                if (requisitionObjectTemp && typeof requisitionObjectTemp.EId !== 'undefined') {
                    _reqStructures.push({
                        'jobEId': requisitionObjectTemp.EId,
                        'jobTemplateVariable': requisitionObjectTemp.templateVariable,
                        'jobTitle': requisitionObjectTemp.title,
                        'requisitionId': requisitionObjectTemp.requisitionId
                    });
                }
            });
            if (_reqStructures && _reqStructures.length > 0) {
                metaDataObj.reqStructures = _reqStructures;
            }
            metaDataObj.fromLabel = $scope.newEmailContents.from;
            //$scope.newEmailContents.metadata = JSON.stringify(metaDataObj);

            var _emailObj = {
                htmlMessage: _htmlMessage,
                metaData: JSON.stringify(metaDataObj),
                subject: $scope.newEmailContents.subject
            };
            if (angular.isDefined($routeParams.meid)) {
                _emailObj.id = $scope.newEmailContents.id;
            }

            // preview specific code.
            if (!!ifPreview) {
                campaignService.getPreviewMessage(_emailObj, function (results) {
                    modalService.showDummyiframe(results);
                });
                return;
            }

            // code for save.
            campaignService.saveEmailTemplate(_emailObj, function (result) {
                if (result.status === 'ok') {
                    $timeout(function () {
                        $location.path('campaign/email/email/' + $routeParams.ceid);
                    }, 500);
                } else {
                    JV.showDropDownMessageError(constantService.TEMPLATE_UNSAVED);
                }
            });
        };

        $scope.selectTemplate = function () {
            var deferredService = $q.defer();
            modalService.getLayout(deferredService);
            deferredService.promise.then(function (templateLayout) {
                $scope.newEmailContents.htmlMessage = selectLayoutService(templateLayout);
            });
        };

        $scope.addRequisition = function (link) {
            campaignService.getRequisitionFilters({}, function (results) {
                var deferredService = $q.defer();
                modalService.selectRequisition(results, deferredService);
                deferredService.promise.then(function (requisitionObject) {
                    if ($scope.reqIds && $scope.reqIds.length > 0 && $.inArray(requisitionObject.EId, $scope.reqIds) !== -1) {
                        //The requisition link token already exists for the campaign.
                    } else {
                        var metadata = {
                            EId: requisitionObject.EId,
                            title: requisitionObject.title
                        };
                        if (requisitionObject.requisitionId) {
                            metadata.requisitionId = requisitionObject.requisitionId.trim();
                        }
                        var reqTitleText = campaignService.getReqTitleText(requisitionObject.title, requisitionObject.requisitionId);
                        var newLink = Draggable(reqTitleText, '[' + reqTitleText + ']', draggableTemplate, metadata);
                        //link is defined when we are trying to edit a requisition link rather than adding a new requisition
                        if (link) {
                            if ($scope.reqIds && $scope.reqIds.indexOf(link.metadata.EId) !== -1) {
                                //When editing a requisition, we have to make sure that  $scope.reqIds has the updated list of reqIds
                                $scope.reqIds.splice($scope.reqIds.indexOf(link.metadata.EId), 1);
                            }
                            angular.extend(link, newLink);
                            //Adding the new edited requisitions jobEId to $scope.reqIds
                            $scope.reqIds.push(newLink.metadata.EId);
                        } else {
                            $scope.requisitionObject.push(newLink);
                            $scope.reqIds.push(requisitionObject.EId);
                        }
                    }
                });
            });
        };

        var counter = 0;

        function openCustomLink(resultSet, index) {
            if (!resultSet) {
                resultSet = {
                    'customTemplates': $scope.customTemplates
                };
            } else {
                resultSet.customTemplates = $scope.customTemplates;
            }
            if (resultSet.text) {
                resultSet.currentLinkText = resultSet.text;
            }
            var deferredService = $q.defer();
            modalService.getLinkDetails(resultSet, deferredService);
            deferredService.promise.then(function (customLinkObj) {
                var draggable = Draggable(customLinkObj.actionName, '[' + customLinkObj.actionName + ']', draggableTemplate, {
                    actionUrl: customLinkObj.actionUrl,
                    actionName: customLinkObj.actionName
                });
                // index means it's an edit.
                if (typeof index === 'undefined') {
                    $scope.customTemplates.push(draggable);
                } else {
                    delete $scope.customTemplates[index];
                    $scope.customTemplates[index] = draggable;
                }
            }, function () {
                // reject
            });
        }



        $scope.addCustomLink = function () {
            openCustomLink(null);
        };

        $scope.editCustomLink = function (link, index) {
            openCustomLink(link, index);
        };

        /************************************************************************************** Edits **************************************************************************************************/
        var fillRequisitionObject = function (metaDataObj) {
            $scope.requisitionObject = [];
            $scope.reqIds = [];
            var item = '';
            if (metaDataObj && metaDataObj.reqStructures) {
                angular.forEach(metaDataObj.reqStructures, function (reqStructure) {
                    if (typeof reqStructure.jobEId === 'undefined' || reqStructure.jobEId == null) {
                        return;
                    }
                    item = {
                        EId: reqStructure.jobEId,
                        title: reqStructure.jobTitle,
                        requisitionId: reqStructure.requisitionId
                    };
                    var reqTitleText = campaignService.getReqTitleText(reqStructure.jobTitle, reqStructure.requisitionId);
                    $scope.requisitionObject.push(Draggable(reqTitleText, reqStructure.jobTemplateVariable, draggableTemplate, item));
                    $scope.reqIds.push(reqStructure.jobEId);
                });
            }
        }

        var fillCustomTemplate = function (metaDataObj) {
            $scope.customTemplates = [];
            angular.forEach(metaDataObj, function (item) {
                $scope.customTemplates.push(Draggable(item.actionName, item.templateVariable, draggableTemplate, item));
            });
            //$scope.customTemplates    
        };

        $timeout(function () {
            //check if the call is for edit or add. Having meid in the route param means its an edit.
            if (angular.isDefined($routeParams.meid)) {
                // get the emails
                campaignService.getEmailContents(null, function (result) {
                    var result = angular.copy(result);
                    angular.forEach(result.resultList, function (item) {
                        if (item.id.toString() === $routeParams.meid) {
                            // transition the data before injecting it in the DOM.
                            if (typeof item.metaData && item.metaData && item.metaData.trim() !== '') {
                                var metaData = JSON.parse(item.metaData);
                                //TODO: do the predefined templates transformation.
                                // customTemplates transformation action.
                                fillCustomTemplate(metaData.actions);
                                // requisition transformation.
                                fillRequisitionObject(metaData);
                                // do for the predefined templates.
                                var allLinks = [].concat($scope.templates.User).concat($scope.templates.Company).concat($scope.customTemplates).concat($scope.requisitionObject);
                                item.htmlMessage = ContentToTinyMceMessage(item.htmlMessage, allLinks);

                                item.from = metaData.fromLabel || window._jvselfUser.fullName;
                            }
                            $scope.newEmailContents = item;
                        }
                    });
                });
            }
        }, 1);

    }
]);




/*************************************************
 **************** Emails Controller ************
 *************************************************/
AppCtrlTinymceModule.controller('EmailsController', ['$scope', 'campaignService', '$location', '$routeParams', 'constantService', 'tabInfoService', 'predefinedTemplates', 'modalService', 'actionModalService', 'Draggable', 'draggableTemplate', 'ContentToTinyMceMessage', 'TinyMceMessageToContent',
    function ($scope, campaignService, $location, $routeParams, constantService, tabInfoService, predefinedTemplates, modalService, actionModalService, Draggable, draggableTemplate, ContentToTinyMceMessage, TinyMceMessageToContent) {
        campaignService.getDetails();
        $scope.showLoading = true;
        $scope.showNoResults = false;
        $scope.messageList = [];
        $scope.originalMessageList = [];

        // Find the counts from the emails.
        function findCount(id, arr) {
            if (angular.isUndefined(arr)) {
                return 0;
            }
            for (var i = 0; i < arr.length; i++) {
                var item = arr[i];
                if (id == item.id) {
                    return item.count;
                }
            }
            return 0;
        }

        // Find the name who sent the email.
        function findName(id, arr) {
            if (angular.isUndefined(arr)) {
                return '';
            }
            for (var i = 0; i < arr.length; i++) {
                var item = arr[i];
                if (id === item.id) {
                    return item.firstName + item.lastName;
                }
            }
            return '';
        }


        // Render the resuls with the ajax call.
        $scope.$on('emailContentsReceived', function (event, results) {
            var tempResult = angular.copy(results.resultList);
            var predefined = [].concat(predefinedTemplates.User).concat(predefinedTemplates.Company);
            var allLinks;
            angular.forEach(tempResult, function (value, key) {
                tempResult[key].duplicateHTML = {};
                // do the message transformation before it gets to the DOM here.
                var item = tempResult[key];
                if (typeof item.metaData && item.metaData && item.metaData.trim() !== '') {
                    var metaData = JSON.parse(item.metaData);
                    if (metaData && Object.keys(metaData).length !== 0) {
                        allLinks = [];
                        if (metaData != null && angular.isDefined(metaData) && metaData.actions != null && typeof metaData.actions !== 'undefined' && metaData.actions.length > 0) {
                            angular.forEach(metaData.actions, function (link) {
                                allLinks.push(Draggable(link.actionName, link.templateVariable, draggableTemplate, []));
                            });
                        }
                        if (metaData != null && angular.isDefined(metaData) && metaData.reqStructures) {
                            angular.forEach(metaData.reqStructures, function (reqStructure) {
                                if (reqStructure && typeof reqStructure.jobTemplateVariable !== 'undefined' && reqStructure.jobTemplateVariable && reqStructure.jobTemplateVariable.trim() !== '') {
                                    var reqTitleText = campaignService.getReqTitleText(reqStructure.jobTitle, reqStructure.requisitionId);
                                    allLinks.push(Draggable(reqTitleText, reqStructure.jobTemplateVariable, draggableTemplate, []));
                                }
                            });
                        }
                        // do for the predefined templates.
                        item.htmlMessage = ContentToTinyMceMessage(item.htmlMessage, predefined);
                        item.htmlMessage = ContentToTinyMceMessage(item.htmlMessage, allLinks);
                    }
                }
                tempResult[key] = item;
                tempResult[key].duplicateHTML.htmlMessage = tempResult[key].htmlMessage || '';
                tempResult[key].duplicateHTML.preview = tempResult[key].preview || '';
                tempResult[key].count = findCount(item.id, results.counts);
                tempResult[key].name = findName(item.id, results.name);
            });
            $scope.showLoading = false;
            if (!tempResult.length) {
                $scope.showNoResults = true;
            }

            $scope.messageList = tempResult;
            $scope.originalMessageList = results.resultList;
            // if not messages then move the control to the editor.
            if (tempResult.length < 1) {
                $scope.openRichEmail();
            }
        });

        //Need to add page loading image
        campaignService.getEmailContents(null, null);
        //BUTTONS

        // What happens when someone cacels the edit email template.
        $scope.cancel = function (index) {
            $scope.messageList[index] = $scope.originalMessageList[index];
        }

        // What happens when you delete the email template.
        $scope.deleteResource = function (index) {
            campaignService.removeEmailTemplate({
                contentEid: $scope.messageList[index]['id']
            }, function (result) {
                if (!!result.status && result.status === 'ok') {
                    window.JV.showDropDownMessage(constantService.TEMPLATE_DELETE);
                    campaignService.getEmailContents();
                } else {
                    window.JV.showDropDownMessageError(constantService.TEMPLATE_NOT_DELETED);
                }
            });
        };


        // update template
        // @param: index: index of the scope for that specific row in the email template UI
        $scope.updateEmailTemplate = function (index) {
            $scope.showLoading = true;
            var emailTemplateObj = angular.copy($scope.messageList[index]);
            $scope.messageList = [];
            // copy the duplicateHTML back to the htmlMessage.
            emailTemplateObj['htmlMessage'] = emailTemplateObj['duplicateHTML']['htmlMessage'];

            // the new template shouldn't have below properties.
            var propertiesToRemove = ['createDate', 'updateDate', 'sentDate', 'scheduleDate', 'duplicateHTML'];
            var allLinks = [].concat(predefinedTemplates.User).concat(predefinedTemplates.Company);
            var metaData = JSON.parse(emailTemplateObj.metaData);
            if (metaData != null && angular.isDefined(metaData) && metaData.actions != null && angular.isDefined(metaData.actions) && metaData.actions.length > 0) {
                angular.forEach(metaData.actions, function (link) {
                    allLinks.push(Draggable(link.actionName, link.templateVariable, draggableTemplate, []));
                });
            }
            if (metaData != null && angular.isDefined(metaData) && metaData.reqStructures) {
                angular.forEach(metaData.reqStructures, function (reqStructure) {
                    if (reqStructure && typeof reqStructure.jobTemplateVariable !== 'undefined' && reqStructure.jobTemplateVariable && reqStructure.jobTemplateVariable.trim() !== '') {
                        allLinks.push(Draggable(reqStructure.jobTitle, reqStructure.jobTemplateVariable, draggableTemplate, []));
                    }
                });
            }
            emailTemplateObj['htmlMessage'] = TinyMceMessageToContent(emailTemplateObj['htmlMessage'], allLinks);

            for (var i = 0, j = propertiesToRemove.length; i < j; i++) {
                delete emailTemplateObj[propertiesToRemove[i]];
            }
            campaignService.saveEmailTemplate(emailTemplateObj,
                function (result) {
                    if (result.status === 'ok') {
                        window.JV.showDropDownMessage(constantService.TEMPLATE_SAVED);
                    } else {
                        window.JV.showDropDownMessageError(constantService.TEMPLATE_UNSAVED);
                    }
                }
            );
        };

        // copy the template.
        $scope.copyResource = function (index) {
            $scope.showLoading = true;
            campaignService.copyEmailTemplate({
                contentId: $scope.messageList[index].id
            }, function (result) {
                var off;
                if (result.status === 'ok') {
                    window.JV.showDropDownMessage(constantService.TEMPLATE_COPIED);
                    off = $scope.$on('emailContentsReceived', function () {
                        off();
                        $scope.editEmail(0);
                    });
                } else {
                    window.JV.showDropDownMessageError(constantService.TEMPLATE_NOT_COPIED);
                }
            });
        };

        $scope.editEmail = function (index) {
            var _messageId = $scope.messageList[index].id;
            $location.path('campaign/email/richEmail/' + $routeParams.ceid + '/' + _messageId);
        };


        // New template saved.
        $scope.$on('emailTemplateSaved', function (event, results) {
            if (results.status === 'ok') {
                campaignService.getEmailContents();
            } else {
                // something went wrong with delete.
                try {
                    console.log('something went wrong with the copy')
                } catch (e) {}
            }
        });

        $scope.openRichEmail = function () {
            $location.path('campaign/email/richEmail/' + $routeParams.ceid);
        };

        $scope.sendEmailToAllContacts = function (index) {
            var messageObj = $scope.originalMessageList[index];
            campaignService.getCampaignContacts(null, function (results) {
                //$scope.removePageLoading();
                if (results.resultList.length > 0) {
                    modalService.getScheduleCampaign(messageObj);
                } else {
                    modalService.noCampaignContacts();
                }
            });
        };

        $scope.showCampaignContacts = function (index) {
            actionModalService.getCampaignContacts({
                campaignEid: $routeParams.ceid,
                templateEid: $scope.originalMessageList[index].id
            }, function (results) {
                modalService.getCampaignContacts(results);
            });
        };

        tabInfoService();
    }
]);